import React from 'react';
import Appearance from 'styles/Appearance.js';
import Utils from 'files/Utils.js';

// Slim credibility strip under the hero. Desktop: a 4-across row with label +
// subtext and hairline dividers. Mobile: a compact 2x2 of single-line badges
// (short copy, accent icons) so it reads as quick trust marks, not a heavy list.
const TrustBar = () => {

    const items = [
        { icon: 'fas fa-flag-usa', label: 'Designed & engineered', sub: 'in the U.S.A.', short: 'Made in the USA' },
        { icon: 'fas fa-shield-alt', label: 'Protecting homes', sub: 'for 10+ years', short: '10+ years' },
        { icon: 'fas fa-hand-holding-usd', label: 'No monthly fees', sub: 'you own it outright', short: 'No monthly fees' },
        { icon: 'fas fa-undo-alt', label: '14-day returns', sub: 'try it risk-free', short: '14-day returns' },
    ];

    const mobile = Utils.isMobile();

    return (
        <section style={{
            width: '100%',
            backgroundColor: Appearance.colors.dark(),
        }}>
            <div style={{
                maxWidth: mobile ? 360 : 1200,
                margin: '0 auto',
                padding: mobile ? '22px 20px' : '28px 40px',
                display: 'grid',
                gridTemplateColumns: mobile ? '1fr 1fr' : 'repeat(4, 1fr)',
                gap: mobile ? '18px 14px' : 0,
            }}>
                {items.map((item, index) => (
                    <div key={index} style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: mobile ? 9 : 14,
                        // Vertical rules between items on desktop only
                        borderLeft: (!mobile && index > 0)
                            ? `1px solid ${Utils.hexToRGBA(Appearance.colors.white, 0.14)}`
                            : 'none',
                    }}>
                        <i className={item.icon} style={{
                            fontSize: mobile ? 16 : 24,
                            color: mobile ? Appearance.colors.primary() : Appearance.colors.white,
                            flexShrink: 0,
                        }} />

                        {mobile ? (
                            <span style={{
                                fontFamily: Appearance.fonts.body,
                                fontWeight: 600,
                                fontSize: 13,
                                color: Appearance.colors.white,
                                whiteSpace: 'nowrap',
                            }}>
                                {item.short}
                            </span>
                        ) : (
                            <div style={{ display: 'flex', flexDirection: 'column', lineHeight: 1.25 }}>
                                <span style={{
                                    fontFamily: Appearance.fonts.body,
                                    fontWeight: 700,
                                    fontSize: 14,
                                    color: Appearance.colors.white,
                                }}>
                                    {item.label}
                                </span>
                                <span style={{
                                    fontFamily: Appearance.fonts.body,
                                    fontWeight: 400,
                                    fontSize: 13,
                                    color: Utils.hexToRGBA(Appearance.colors.white, 0.6),
                                }}>
                                    {item.sub}
                                </span>
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </section>
    );
};

export default TrustBar;
